import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { AuthService } from '../../services/auth.service';
import { BaseComponent } from '../base/base.component';

interface TableData {
  total: number;
  pageSize: number;
  page: number;
}

interface PagedResponse {
  results?: Array<any> | null;
  page?: number;
  pageSize?: number;
  totalPages?: number;
  totalResults?: number;
}

export class BasePagedComponent extends BaseComponent {
  tableData: TableData = {
    total: 0,
    pageSize: 0,
    page: 0,
  };

  constructor(
    authService: AuthService,
    translateService: TranslateService,
    messageService: NzMessageService
  ) {
    super(authService, translateService, messageService);
  }

  tableParamsChanged(params: NzTableQueryParams) {
    this.tableData.pageSize = params.pageSize;
    this.tableData.page = params.pageIndex;
    this.loadData();
  }

  loadData() {}

  pageLoaded(response: PagedResponse) {
    this.tableData.total = response.totalResults || 0;
    this.tableData.pageSize = response.pageSize || 0;
    this.tableData.page = response.page || 0;
  }
}
